$shm_hitalama_entity_catalog $mol_book2_catalog
	menu_title \
	param \
	list null
	spread_pages_deep /
	menu_tools /
		<= Add $mol_button_minor
			hint \Добавить
			click? <=> add? null
			sub /
				<= Add_icon $mol_icon_plus
	title_default \Новый
	entities /$giper_baza_entity
	Page* $shm_hitalama_entity_page
		entity <= entity* $giper_baza_entity
		cut <= cut* null
